<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Type Codes</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Id" v-model="id" :rules="[rules.numeric]"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="codeSetId"
                                    :items="codeSets"
                                    label="Code Set"
                                        item-text="name"
                                        item-value="id">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Code" v-model="code"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Name" v-model="name"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Description" v-model="description"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Extra Info" v-model="extraInfo"></v-text-field>
                                </v-flex>
                                <!-- <v-flex xs2 ml-4>
                                    <v-text-field label="Extra Definition" v-model="extraDefinition"></v-text-field>
                                </v-flex> -->
                                <v-flex xs2 ml-4>
                                    <v-select label="Deleted" v-model="deleted" :items="deletedItems"></v-select>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                          <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                          <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="typeCodes.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                              <template v-slot:item.name="{item}">
                                <td>
                                    <router-link v-if="isSUPro" to="" @click.native="editItem(item)">{{item.name}}</router-link>
                                    <span v-else>{{item.name}}</span>
                                </td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.codeSetId="{item}">
                                <td>{{codeSetsObj[item.codeSetId]}}</td>
                              </template>
                              <template v-slot:item.deleted="{item}">
                                <td>{{item.deleted ? 'yes' : 'no' }}</td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                <td class="actions" v-if="isSUPro">
                                  <v-btn text icon @click="editItem(item)"
                                  style="height: 0px; width: 0px; padding-right:2px;">
                                      <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                  </v-btn>
                                
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="newItem()">New Code</v-btn>
                </v-card-actions>
            </v-card>
            <v-dialog v-model="showEditTypeCodeDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">User</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validUser" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 class="subheading">
                                   Id: {{editedItem.id}} Codeset Id: {{editedItem.codeSetId}} ({{codeSetsObj[editedItem.codeSetId]}})
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select :items="codeSets" v-model="editedItem.codeSetId" item-text="name"
                                        item-value="id" :rules="[rules.required]" label="Codeset"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.code" :rules="[rules.required]" label="Code"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.extraInfo" label="Extra Info"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-checkbox v-model="editedItem.deleted" label="Deleted"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-textarea v-model="editedItem.extraDefinition" label="Extra Definition"></v-textarea>
                                </v-flex>
                                <!-- //id, code, deleted, name, description, extraInfo, codeSetId, extraDefinition -->

                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="mr-4" color="primary" outlined rounded  @click.native="close">Cancel</v-btn>
                        <v-btn color="primary" rounded  :disabled="!validUser" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            isSU: 'isSU',
            isSUPro: 'isSUPro'
        })
    },
    data() {
        return {
            typeCodes: {
                "content": [],
                "totalElements": 0
            },
            codeSets: [],
            codeSetsObj: {},
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [ //id, codeSetId, code, name, description, extraInfo, extraDefinition, updatedBy, updatedDate
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Codeset Id', align: 'left', sortable: true, value: 'codeSetId'},
                {text: 'Code', align: 'left', sortable: true, value: 'code'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Description', align: 'left', sortable: true, value: 'description'},
                {text: 'Extra Info', align: 'left', sortable: true, value: 'extraInfo'},
                {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
                //{text: 'Extra Definition', align: 'left', sortable: true, value: 'extraDefinition'},
                {text: 'Updated By', align: 'left', sortable: true, value: 'updatedBy'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'}
            ],
            deleted: null,
            codeSetId: null,
            name: null,
            code: null,
            description: null,
            extraInfo: null,
            extraDefinition: null,
            id: null,
            rules: {
                required: value => !!value || 'Required.',
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            showFilters: true,
            validUser: false,
            showEditTypeCodeDialog: false,
            originalItem: null,
            editedItem: {
                id: -1,
                codeSetId: null,
                name: '',
                deleted: false,
                code: '',
                description: '',
                extraInfo: '',
                extraDefinition: ''
            },
            defaultItem: {
                id: -1,
                codeSetId: null,
                name: '',
                deleted: false,
                code: '',
                description: '',
                extraInfo: '',
                extraDefinition: ''
            },
            deletedItems:[
                {text: 'All', value: null},
                {text: 'Deleted only', value: true},
                {text: 'Non-deleted only', value: false}
            ]
        }
    },
    async created() {
        if (this.isSUPro) {
            this.headers.push({text: 'Actions', align: 'left', sortable: false, value: 'actions'})
        }
        const codeSets = await this.$store.dispatch('crossorg/getCodeSets')

        this.codeSets = codeSets

        this.codeSetsObj = _.reduce(codeSets , function(obj,param) {
                obj[param.id] = param.name
                return obj;
        }, {});
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let id = this.id ? +this.id : this.id

            //id, code, deleted, name, description, extraInfo, codeSetId, extraDefinition

            let filter = Utility.buildQueryString(
                ['id', 'code', 'deleted', 'name', 'description', 'extraInfo', 'codeSetId', 'extraDefinition'],
                [id, this.code, this.deleted, this.name, this.description, this.extraInfo, this.codeSetId, this.extraDefinition],
                ['code', 'name', 'description', 'extraInfo', 'extraDefinition'])

            this.loading = true

            this.typeCodes = await this.$store.dispatch('crossorg/getTypeCodes',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.typeCodes.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            if (!val) {
                return ''
            }
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.id = null
            this.code = null
            this.deleted = null
            this.name = null
            this.description = null
            this.extraInfo = null
            this.codeSetId = null
            this.extraDefinition = null

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        async editItem (item) {
            this.originalItem = item
            this.editedItem = Object.assign({}, item)
            this.showEditTypeCodeDialog = true
        },
        close() {
            this.showEditTypeCodeDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.originalItem = null
            }, 300)
        },
        async save () {
            if (this.originalItem) {
                await this.$store.dispatch("crossorg/updateTypeCode", {typeCode: this.editedItem,
                                        patchObject: Utility.createPatchObject(this.originalItem, this.editedItem)})
            } else {
                await this.$store.dispatch("crossorg/upsertTypeCode", {typeCode: this.editedItem})
            }
            this.close()

            await this.refresh(this.pagination)
        },
        newItem() {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.originalItem = null
            this.showEditTypeCodeDialog = true
        },
    }
}
</script>
